import { render, staticRenderFns } from "./BaseDecoratorWrapper.vue?vue&type=template&id=62119267&scoped=true&"
import script from "./BaseDecoratorWrapper.vue?vue&type=script&lang=js&"
export * from "./BaseDecoratorWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BaseDecoratorWrapper.vue?vue&type=style&index=0&id=62119267&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62119267",
  null
  
)

export default component.exports